(function () {
  if (window.__roastProfileSectionInit) return;
  window.__roastProfileSectionInit = true;

  var AMCHART_SOURCES = [
    'https://cdn.amcharts.com/lib/5/index.js',
    'https://cdn.amcharts.com/lib/5/xy.js',
    'https://cdn.amcharts.com/lib/5/themes/Animated.js'
  ];

  var loadedScriptMap = {};

  function isBlank(value) {
    if (value === null || value === undefined) return true;
    if (typeof value === 'string') return value.trim() === '';
    if (Array.isArray(value)) return value.length === 0;
    return false;
  }

  function normalizeValue(value) {
    if (isBlank(value)) return '';

    var text = String(value).trim();
    if (!text) return '';
    if (text.toLowerCase() === 'n/a') return '';
    if (text.toLowerCase() === 'null') return '';
    if (text.toLowerCase() === 'undefined') return '';

    return text;
  }

  function isDebugEnabled(section) {
    if (!section) return false;
    if (section.dataset.debug === 'true') return true;
    return window.location.search.indexOf('debug_roast_profile=1') > -1;
  }

  function debugLog(section, label, payload) {
    if (!isDebugEnabled(section)) return;
    // eslint-disable-next-line no-console
    console.log('[Roast Profile]', label, payload);
  }

  function parseMaybeJson(value) {
    if (isBlank(value)) return null;
    if (typeof value === 'object') return value;
    if (typeof value !== 'string') return value;

    var parsed = value;

    // Some Shopify metafield payloads arrive as JSON encoded as a JSON string.
    // Parse up to 3 passes so strings like "\"{\\\"profile_id_cropster\\\":\\\"Lp2wo\\\"}\""
    // become a plain object.
    for (var i = 0; i < 3; i += 1) {
      if (typeof parsed !== 'string') return parsed;

      var trimmed = parsed.trim();
      if (!trimmed) return null;

      var firstChar = trimmed.charAt(0);
      var lastChar = trimmed.charAt(trimmed.length - 1);
      var looksLikeJson = firstChar === '{' || firstChar === '[';
      var looksLikeQuotedJson = firstChar === '"' && lastChar === '"';

      if (!looksLikeJson && !looksLikeQuotedJson) return trimmed;

      try {
        parsed = JSON.parse(trimmed);
      } catch (error) {
        return trimmed;
      }
    }

    return parsed;
  }

  function loadScript(src) {
    if (loadedScriptMap[src]) return loadedScriptMap[src];

    loadedScriptMap[src] = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-roast-profile-lib="' + src + '"]');
      if (existing) {
        existing.addEventListener('load', function () {
          resolve();
        });
        existing.addEventListener('error', function () {
          reject(new Error('Failed to load ' + src));
        });
        if (existing.dataset.loaded === 'true') resolve();
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.defer = true;
      script.dataset.roastProfileLib = src;

      script.onload = function () {
        script.dataset.loaded = 'true';
        resolve();
      };

      script.onerror = function () {
        reject(new Error('Failed to load ' + src));
      };

      document.head.appendChild(script);
    });

    return loadedScriptMap[src];
  }

  function ensureAmCharts() {
    if (window.am5 && window.am5xy) return Promise.resolve();

    return Promise.all(
      AMCHART_SOURCES.map(function (src) {
        return loadScript(src);
      })
    );
  }

  function normalizeHexColor(value, fallback) {
    var input = normalizeValue(value);
    if (!input) return fallback;

    if (input.charAt(0) !== '#') return fallback;
    if (input.length === 4) {
      return (
        '#' +
        input.charAt(1) + input.charAt(1) +
        input.charAt(2) + input.charAt(2) +
        input.charAt(3) + input.charAt(3)
      ).toUpperCase();
    }

    if (input.length === 7) return input.toUpperCase();
    return fallback;
  }

  function toAm5Color(value, fallbackHex) {
    var hex = normalizeHexColor(value, fallbackHex);
    return am5.color(parseInt(hex.slice(1), 16));
  }

  function readSectionJson(section, selector) {
    var node = section.querySelector(selector);
    if (!node) return null;
    return parseMaybeJson(node.textContent);
  }

  function pickField(candidates, fieldName) {
    for (var i = 0; i < candidates.length; i += 1) {
      var candidate = candidates[i];
      if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) continue;
      if (!isBlank(candidate[fieldName])) return candidate[fieldName];
    }

    return null;
  }

  function resolveKirbyCandidates(section) {
    var metafieldRaw = readSectionJson(section, '[data-roast-profile-kirby-metafield]');
    var contentRaw = readSectionJson(section, '[data-roast-profile-kirby-content]');
    var valueRaw = readSectionJson(section, '[data-roast-profile-kirby-content-value]');

    var metafield = parseMaybeJson(metafieldRaw);
    var content = parseMaybeJson(contentRaw);
    var value = parseMaybeJson(valueRaw);
    var metafieldValue = null;

    if (metafield && typeof metafield === 'object' && !Array.isArray(metafield) && metafield.value !== undefined) {
      metafieldValue = parseMaybeJson(metafield.value);
    }

    var nested = null;
    var nestedCandidates = [metafield, metafieldValue, value, content];
    for (var i = 0; i < nestedCandidates.length; i += 1) {
      var nestedCandidate = nestedCandidates[i];
      if (!nestedCandidate || typeof nestedCandidate !== 'object' || Array.isArray(nestedCandidate)) continue;
      if (nestedCandidate.content === undefined) continue;

      nested = parseMaybeJson(nestedCandidate.content);
      if (nested) break;
    }

    var candidates = [nested, metafieldValue, value, metafield, content];
    debugLog(section, 'Kirby candidates', candidates);
    return candidates;
  }

  function formatFriendlyDate(epochValue) {
    if (isBlank(epochValue)) return 'N/A';

    var timestamp = Number(epochValue);
    if (Number.isNaN(timestamp)) return String(epochValue);

    var date = new Date(timestamp);
    if (Number.isNaN(date.getTime())) return 'N/A';

    var now = new Date();
    var yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);

    var timeString = date.toLocaleTimeString(undefined, {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });

    if (date.toDateString() === now.toDateString()) {
      return 'Today at ' + timeString;
    }

    if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday at ' + timeString;
    }

    return date.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric'
    });
  }

  function formatTemp(value) {
    if (isBlank(value)) return 'N/A';

    var number = Number(value);
    if (Number.isNaN(number)) return String(value);

    return number + ' °F';
  }

  function formatDurationFromSeconds(durationSeconds) {
    var seconds = Number(durationSeconds);
    if (Number.isNaN(seconds) || seconds <= 0) return 'N/A';

    var roundedMinutes = Math.round(seconds / 60);
    if (roundedMinutes < 1) roundedMinutes = 1;

    return roundedMinutes + ' minutes';
  }

  function parseDurationSeconds(rawValue) {
    var value = Number(rawValue);
    if (Number.isNaN(value) || value <= 0) return null;

    // Most roast runs are well under 1 hour.
    if (value <= 3600) return value;

    // Some APIs send duration in milliseconds.
    if (value > 3600 && value <= 3600000) {
      var asSeconds = value / 1000;
      if (asSeconds > 0 && asSeconds <= 3600) return asSeconds;
    }

    return null;
  }

  function durationSecondsFromSeries(beanSeries) {
    if (!Array.isArray(beanSeries) || beanSeries.length < 2) return null;

    var lastPoint = beanSeries[beanSeries.length - 1];
    if (!lastPoint) return null;

    var seconds = Number(lastPoint.time);
    if (Number.isNaN(seconds) || seconds <= 0) return null;

    return seconds;
  }

  function formatDurationFromBatch(batch, beanSeries) {
    var seriesSeconds = durationSecondsFromSeries(beanSeries);
    if (seriesSeconds) return formatDurationFromSeconds(seriesSeconds);

    if (batch && typeof batch === 'object') {
      var durationFields = [batch.duration_seconds, batch.duration, batch.total_seconds];

      for (var i = 0; i < durationFields.length; i += 1) {
        var parsedSeconds = parseDurationSeconds(durationFields[i]);
        if (parsedSeconds) return formatDurationFromSeconds(parsedSeconds);
      }
    }

    return 'N/A';
  }

  function resolveBatchId(batch) {
    if (!batch || typeof batch !== 'object') return 'N/A';

    var batchId =
      batch.batch_number ||
      batch.batchNumber ||
      batch.batch_id ||
      batch.batchId ||
      batch.roast_id ||
      batch.roastId ||
      batch.id;

    var normalized = normalizeValue(batchId);
    if (!normalized) return 'N/A';

    return normalized.charAt(0) === '#' ? normalized : '#' + normalized;
  }

  function resolveBatchRoaster(batch) {
    if (!batch || typeof batch !== 'object') return 'N/A';

    return normalizeValue(batch.roaster || batch.technician || batch.operator || batch.user) || 'N/A';
  }

  function resolveBatchStartTemp(batch) {
    if (!batch || typeof batch !== 'object') return 'N/A';

    return formatTemp(batch.start_temp || batch.charge_temp || batch.chargeTemp);
  }

  function resolveBatchEndTemp(batch) {
    if (!batch || typeof batch !== 'object') return 'N/A';

    return formatTemp(batch.end_temp || batch.finish_temp || batch.finishTemp);
  }

  function calculateRateOfRise(series, smoothWindow) {
    var result = [];

    for (var i = 1; i < series.length; i += 1) {
      var prev = series[i - 1];
      var curr = series[i];

      var deltaTime = curr.time - prev.time;
      var deltaValue = curr.value - prev.value;
      var rate = deltaTime !== 0 ? deltaValue / deltaTime : 0;

      if (rate < 0) rate = 0;

      result.push({
        time: curr.time,
        value: rate * 30
      });
    }

    if (!smoothWindow || smoothWindow <= 1) return result;

    var smoothed = [];
    var halfWindow = Math.floor(smoothWindow / 2);

    for (var index = 0; index < result.length; index += 1) {
      var sum = 0;
      var count = 0;

      for (var j = index - halfWindow; j <= index + halfWindow; j += 1) {
        if (j < 0 || j >= result.length) continue;
        sum += result[j].value;
        count += 1;
      }

      smoothed.push({
        time: result[index].time,
        value: count > 0 ? Math.round((sum / count) * 10) / 10 : 0
      });
    }

    return smoothed;
  }

  function normalizeBeanSeries(rawSeries) {
    if (!rawSeries || typeof rawSeries !== 'object') return [];

    var entries = [];

    Object.keys(rawSeries).forEach(function (key) {
      var time = Number(key);
      var rawValue = Number(rawSeries[key]);
      if (Number.isNaN(time) || Number.isNaN(rawValue)) return;

      entries.push({
        time: time,
        value: rawValue / 10
      });
    });

    entries.sort(function (a, b) {
      return a.time - b.time;
    });

    return entries;
  }

  function setText(section, selector, value) {
    var node = section.querySelector(selector);
    if (!node) return;
    node.textContent = isBlank(value) ? 'N/A' : String(value);
  }

  function showNotice(section, message) {
    var notice = section.querySelector('[data-roast-profile-notice]');
    if (!notice) return;

    notice.hidden = false;
    if (message) notice.textContent = message;
  }

  function setUnavailableState(section, message) {
    section.classList.add('roast-profile--no-data');
    showNotice(section, message);
  }

  function hideSectionIfNeeded(section) {
    if (section.dataset.designMode === 'true') {
      setUnavailableState(section, 'Roast profile data is unavailable for this product.');
      return;
    }

    section.classList.add('roast-profile--hidden');
  }

  function disposeChart(section) {
    var chartNode = section.querySelector('.roast-profile__chart');
    if (!chartNode || !chartNode.__roastProfileRoot) return;

    chartNode.__roastProfileRoot.dispose();
    chartNode.__roastProfileRoot = null;
  }

  function renderChart(section, beanSeries, rorSeries, lineColors) {
    var chartNode = section.querySelector('.roast-profile__chart');
    if (!chartNode) return;

    var beanLineColor = toAm5Color(lineColors && lineColors.bean, '#A57044');
    var rorLineColor = toAm5Color(lineColors && lineColors.ror, '#A12F30');

    disposeChart(section);

    var root = am5.Root.new(chartNode.id);
    chartNode.__roastProfileRoot = root;

    root.setThemes([am5themes_Animated.new(root)]);

    var chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        maxTooltipDistance: 5,
        panX: false,
        panY: false,
        wheelX: 'none',
        wheelY: 'none'
      })
    );

    var xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        strictMinMax: true,
        min: 0,
        max: beanSeries[beanSeries.length - 1].time,
        renderer: am5xy.AxisRendererX.new(root, {})
      })
    );

    xAxis.get('renderer').labels.template.setAll({
      fill: am5.color(0x9f9f9f),
      fontSize: '0.82em'
    });

    var yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        strictMinMax: true,
        renderer: am5xy.AxisRendererY.new(root, {})
      })
    );

    yAxis.get('renderer').grid.template.setAll({
      stroke: am5.color(0x4f4f4f),
      strokeWidth: 1
    });

    yAxis.get('renderer').labels.template.setAll({
      fill: am5.color(0x9f9f9f),
      fontSize: '0.82em'
    });

    var rorAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        strictMinMax: true,
        min: 0,
        renderer: am5xy.AxisRendererY.new(root, { opposite: true })
      })
    );

    rorAxis.get('renderer').grid.template.setAll({
      stroke: am5.color(0x4f4f4f),
      strokeWidth: 1
    });

    rorAxis.get('renderer').labels.template.setAll({
      fill: am5.color(0x9f9f9f),
      fontSize: '0.82em'
    });

    var beanTooltip = am5.Tooltip.new(root, {
      getFillFromSprite: false,
      pointerOrientation: 'horizontal',
      labelText: '[fontFamily: Andale Mono]{valueY}°F\\n{valueX} sec[/]',
      autoTextColor: false
    });

    beanTooltip.get('background').setAll({
      fill: am5.color(0x000000),
      fillOpacity: 0.35,
      strokeOpacity: 0
    });

    beanTooltip.label.setAll({
      fill: beanLineColor
    });

    var beanSeriesChart = chart.series.push(
      am5xy.SmoothedXLineSeries.new(root, {
        name: 'Bean Temp',
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: 'value',
        valueXField: 'time',
        stroke: beanLineColor,
        tooltip: beanTooltip
      })
    );

    beanSeriesChart.strokes.template.setAll({
      strokeWidth: 2
    });

    beanSeriesChart.data.setAll(beanSeries);

    var rorTooltip = am5.Tooltip.new(root, {
      getFillFromSprite: false,
      pointerOrientation: 'horizontal',
      labelText: '[fontFamily: Andale Mono]{valueY}Δ°F/s\\n{valueX} sec[/]',
      autoTextColor: false
    });

    rorTooltip.get('background').setAll({
      fill: am5.color(0x000000),
      fillOpacity: 0.35,
      strokeOpacity: 0
    });

    rorTooltip.label.setAll({
      fill: rorLineColor
    });

    var rorSeriesChart = chart.series.push(
      am5xy.SmoothedXLineSeries.new(root, {
        name: 'RoR Temp',
        xAxis: xAxis,
        yAxis: rorAxis,
        valueYField: 'value',
        valueXField: 'time',
        stroke: rorLineColor,
        tooltip: rorTooltip
      })
    );

    rorSeriesChart.strokes.template.setAll({
      strokeWidth: 2
    });

    rorSeriesChart.data.setAll(rorSeries);

    var cursor = chart.set(
      'cursor',
      am5xy.XYCursor.new(root, {
        behavior: 'none'
      })
    );

    cursor.lineY.set('visible', false);
    cursor.lineX.setAll({
      stroke: am5.color(0x9f9f9f),
      strokeWidth: 1
    });

    chart.appear(700, 120);
  }

  function resolveProfileAndMachine(section) {
    var candidates = resolveKirbyCandidates(section);

    var dataProfile = normalizeValue(section.dataset.profileId);
    var dataMachine = normalizeValue(section.dataset.roastMachine);

    var candidateProfile = normalizeValue(pickField(candidates, 'profile_id_cropster'));
    var candidateMachine = normalizeValue(pickField(candidates, 'roasting_machine'));

    var profileId = dataProfile || candidateProfile;
    var machine = dataMachine || candidateMachine;

    if (!isBlank(profileId) && String(profileId).indexOf('shopify_slug') > -1) {
      profileId = '';
    }

    var resolved = {
      profileId: normalizeValue(profileId),
      machine: normalizeValue(machine) || 'N/A'
    };

    debugLog(section, 'Resolved profile/machine', {
      dataProfile: dataProfile,
      candidateProfile: candidateProfile,
      resolvedProfile: resolved.profileId,
      dataMachine: dataMachine,
      candidateMachine: candidateMachine,
      resolvedMachine: resolved.machine
    });

    return resolved;
  }

  function fillStaticMachine(section, machine) {
    setText(section, '[data-roast-machine]', machine || 'N/A');
  }

  function initRoastProfileSection(section) {
    if (!section || section.dataset.roastProfileReady === 'true') return;
    section.dataset.roastProfileReady = 'true';

    var resolved = resolveProfileAndMachine(section);
    fillStaticMachine(section, resolved.machine);

    var shouldHideWithoutProfile = section.dataset.hideWithoutProfile === 'true';

    if (!resolved.profileId) {
      debugLog(section, 'Missing profile id', {
        hideWithoutProfile: shouldHideWithoutProfile
      });
      if (shouldHideWithoutProfile) {
        hideSectionIfNeeded(section);
      } else {
        setUnavailableState(section, 'Roast profile data is unavailable for this product.');
      }
      return;
    }

    var requestUrl =
      'https://onyx-data.herokuapp.com/api/cropster/most-recent-roast?profile=' +
      encodeURIComponent(resolved.profileId);

    debugLog(section, 'Fetching roast profile', {
      url: requestUrl,
      profileId: resolved.profileId
    });

    fetch(requestUrl)
      .then(function (response) {
        debugLog(section, 'Fetch response', {
          ok: response.ok,
          status: response.status,
          statusText: response.statusText
        });
        if (!response.ok) throw new Error('Failed roast profile response');
        return response.json();
      })
      .then(function (payload) {
        var batch = payload && payload.batch ? payload.batch : null;
        var beanSeries = normalizeBeanSeries(batch ? batch.data : null);
        debugLog(section, 'Payload batch summary', {
          hasBatch: !!batch,
          batchKeys: batch ? Object.keys(batch) : [],
          beanSeriesPoints: beanSeries.length
        });

        if (!batch || beanSeries.length < 3) {
          debugLog(section, 'Insufficient batch data', {
            hideWithoutProfile: shouldHideWithoutProfile
          });
          if (shouldHideWithoutProfile) hideSectionIfNeeded(section);
          else setUnavailableState(section, 'No roast profile batch data available.');
          return;
        }

        var rorSeries = calculateRateOfRise(beanSeries, 30);
        var lineColors = {
          bean: normalizeValue(section.dataset.beanLineColor),
          ror: normalizeValue(section.dataset.rorLineColor)
        };

        setText(section, '[data-roast-date]', formatFriendlyDate(batch.date));
        setText(section, '[data-roast-id]', resolveBatchId(batch));
        setText(section, '[data-roast-tech]', resolveBatchRoaster(batch));
        setText(section, '[data-roast-charge]', resolveBatchStartTemp(batch));
        setText(section, '[data-roast-finish]', resolveBatchEndTemp(batch));
        setText(section, '[data-roast-duration]', formatDurationFromBatch(batch, beanSeries));

        ensureAmCharts()
          .then(function () {
            debugLog(section, 'Rendering chart', {
              beanPoints: beanSeries.length,
              rorPoints: rorSeries.length,
              lineColors: lineColors
            });
            renderChart(section, beanSeries, rorSeries, lineColors);
          })
          .catch(function (error) {
            debugLog(section, 'Chart library error', error);
            if (shouldHideWithoutProfile) hideSectionIfNeeded(section);
            else setUnavailableState(section, 'Chart library failed to load.');
          });
      })
      .catch(function (error) {
        debugLog(section, 'Roast fetch error', error);
        if (shouldHideWithoutProfile) hideSectionIfNeeded(section);
        else setUnavailableState(section, 'Could not load roast profile data.');
      });
  }

  function init(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('[data-roast-profile]');

    for (var i = 0; i < sections.length; i += 1) {
      initRoastProfileSection(sections[i]);
    }
  }

  function cleanup(root) {
    if (!root) return;

    var sections = root.matches && root.matches('[data-roast-profile]') ? [root] : root.querySelectorAll('[data-roast-profile]');
    for (var i = 0; i < sections.length; i += 1) {
      disposeChart(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    cleanup(event.target);
  });
})();
